/* eslint-disable jsx-a11y/alt-text */
import styled from "styled-components";
import { Link } from "react-router-dom";
import { useContext } from "react";
import UserContext from "../context/UserContext";
import arraste from "../imgs/arraste.svg";

import { Main, Container, Voltar } from "./GlobalStyled.js";

export default function Calibragem() {
  const { tamCartao, setTamCartao } = useContext(UserContext);
  return (
    <Main>
      <Container>
        <Cartao largura={`${tamCartao}px`}></Cartao>

        <Botoes>
          <img src={arraste} />
          <input
            type="range"
            name="tamanho"
            min="100"
            max="350"
            step="1"
            value={tamCartao}
            onChange={(e) => setTamCartao(e.target.value)}
          />
          <Link to={"/medicao-com-anel"}>
            <button>Pronto, já calibrei!</button>
          </Link>
          <Link to={"/instrucao-calibragem"}>
            <Voltar>Voltar</Voltar>
          </Link>
        </Botoes>
      </Container>
    </Main>
  );
}

const Cartao = styled.div`
  width: 90vw;
  height: ${(props) => props.largura};
  border-top: 5px solid #2a0670;
  border-bottom: 5px solid #2a0670;
  background-color: #cdbee7;
  position: absolute;
  top: 100px;

  @media (min-width: 1300px) {
    top: 5%;
  }
`;

const Botoes = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 10px;

  input {
    -webkit-appearance: none;
    appearance: none;
    border-radius: 5px;
    background: #cdbee7;
    outline: none;
    width: 60vw;
    height: 10px;
    margin: 10px 20px;
  }

  input::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #2a0670;
    cursor: pointer;
  }

  input::-moz-range-thumb {
    width: 25px;
    height: 25px;
    border-radius: 50%;
    background: #2a0670;
    cursor: pointer;
  }

  button {
    width: 80vw;
    height: auto;
    margin: 20px;
    padding: 20px;
    background-color: #cdbee7;
    color: #2a0670;
    border-radius: 10px;
    font-size: 18px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #2a0670;

    cursor: pointer;
  }

  img {
    max-width: 150px;
    margin-left: -40vw;
    margin-bottom: -30px;
  }
`;
